<div id="componentContainer" class="component-container">
  <div id="messageContainer" class="message-container">
    @if (!failedLocalServerRun) {
      <div id="connectionMessage" class="connection-message">
        <div class="description" class="description">
          <h3 id="description" class="heading">IMPACT requires an active Internet connection.<br>Please check your connectivity.</h3>
        </div>
        <div id="retryButton" class="retry-button">
          <button mat-button class="button primary" (click)="retryConnectionToInternet()">
            Retry
          </button>
        </div>
      </div>
    } @else {
      <div id="connectionMessage" class="connection-message">
        <div class="description" class="description">
          <h3 id="description" class="heading">Unable to connect to the server.<br>Restarting your computer could help.</h3>
        </div>
        <div id="retryButton" class="retry-button">
          <button mat-button class="button primary" (click)="retryConnectionToInternet()">
            Close IMPACT application
          </button>
        </div>
      </div>
    }
    <div id="iconConnection" class="icon-wrapper">
      <span class="crm-industrial-font icon-internet-base"></span>
      <span class="crm-industrial-font icon-internet-wire animate-top"></span>
    </div>
  </div>
</div>

